import axios from 'axios';
import { getApiUrl } from '../../../config';

export function requestCheckEmailAvailability(email) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/auth/checkEmailAvailability",
        params: { email },
    });
}